import {
	ORDER_BY_DIRECTION_ASC,
	ORDER_BY_DIRECTION_DESC,
	type OrderByDirectionValue,
} from '@atlaskit/jql-ast';

export const toggleDirection = (previousDirection: OrderByDirectionValue): OrderByDirectionValue =>
	previousDirection === ORDER_BY_DIRECTION_ASC ? ORDER_BY_DIRECTION_DESC : ORDER_BY_DIRECTION_ASC;
